module.exports = __webpack_public_path__ + "static/media/gallery08.8236d084.jpg";